function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { connect } from 'react-redux';
import { notificationActions } from '../../reducers/notification.reducer';
import { FaTimes } from 'react-icons/fa';
var Toast = /*#__PURE__*/function (_React$Component) {
  function Toast(props) {
    var _this;
    _classCallCheck(this, Toast);
    _this = _callSuper(this, Toast, [props]);
    _this.close = _this.close.bind(_this);
    return _this;
  }
  _inherits(Toast, _React$Component);
  return _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      var _this$props = this.props,
        sticky = _this$props.sticky,
        timer = _this$props.timer;
      if (!sticky) setTimeout(function () {
        self.close(false);
      }, timer);
    }
  }, {
    key: "close",
    value: function close() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        removeToastAction = _this$props2.removeToastAction;
      $("#".concat(id, " .toast__content")).css({
        left: '400px',
        opacity: 0
      });
      $("#".concat(id)).css({
        height: parseInt($("#".concat(id)).css('height'))
      });
      setTimeout(function () {
        $("#".concat(id)).css({
          height: 0,
          'padding-top': 0
        });
        setTimeout(function () {
          removeToastAction(id);
        }, 400);
      }, 400);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        message = _this$props3.message,
        type = _this$props3.type;
      var icon = '';
      switch (type) {
        case 'warning':
          icon = 'exclamation-triangle';
          break;
        case 'info':
          icon = 'info';
          break;
        case 'error':
          icon = 'bomb';
          break;
        default:
          icon = 'check';
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "toast",
        id: id
      }, /*#__PURE__*/React.createElement("div", {
        className: "toast__content toast__content--".concat(type)
      }, /*#__PURE__*/React.createElement("div", {
        className: "toast__icon toast__icon--".concat(type)
      }), /*#__PURE__*/React.createElement("div", {
        className: "toast__text"
      }, message), /*#__PURE__*/React.createElement("div", {
        className: "toast__close",
        onClick: function onClick() {
          _this2.close();
        }
      }, /*#__PURE__*/React.createElement(FaTimes, null))));
    }
  }]);
}(React.Component);
var mdtp = {
  removeToastAction: notificationActions.removeToast
};
export default connect(null, mdtp)(Toast);